import React from 'react';
import type { Dispatch, SetStateAction } from 'react';
import {
  Icon,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from '@saviynt/design-system';
import cx from 'classnames';

import { useChatOverlayContext } from '../../../../context/chatOverlayContext';
import { TABLE_HEADER_TOOLTIP } from '../../../../tests/testids';
import { TOGGLE_VALUES, type ToggleSelectionType } from '../../types';

import './TableHeader.css';

interface TableHeaderProps {
  numRecords: number;
  toggleSelection?: ToggleSelectionType;
  setToggleSelection?: Dispatch<SetStateAction<ToggleSelectionType>>;
}
TableHeader.defaultProps = {
  toggleSelection: undefined,
  setToggleSelection: () => {},
};

function TableHeader({
  numRecords,
  toggleSelection,
  setToggleSelection,
}: TableHeaderProps): JSX.Element {
  const { chatOverlayState } = useChatOverlayContext();

  const detailedSteps =
    'detailedSteps' in chatOverlayState.contentPanelData
      ? chatOverlayState.contentPanelData.detailedSteps
      : [];

  const tooltipSteps = Array.isArray(detailedSteps)
    ? detailedSteps.join(' ')
    : '';

  return (
    <section className='Ispm-TableHeader'>
      <div className='Ispm-TableHeader-contentWrapper'>
        <span
          className={cx(
            'Ispm-TableHeader-contentWrapper-numRecords',
            toggleSelection === TOGGLE_VALUES.SQL &&
              'Ispm-TableHeader-contentWrapper-numRecords--isHidden'
          )}>
          Number of records: {numRecords}
        </span>

        <span className='Ispm-TableHeader-contentWrapper-toggleGroup'>
          {toggleSelection === TOGGLE_VALUES.SQL && (
            <Tooltip
              text={tooltipSteps}
              placement='left'
              dataTestId={TABLE_HEADER_TOOLTIP}
              trigger={<Icon kind='Info' color='info-700' size='xSmall' />}
            />
          )}

          <ToggleButtonGroup
            selection={toggleSelection}
            setSelection={setToggleSelection}
            isPill>
            <ToggleButton
              size='small'
              icon={
                <Tooltip
                  text='View Visualization'
                  placement='top'
                  offset={20}
                  trigger={
                    <Icon kind='DataAnalyze' size='small' color='navy-900' />
                  }
                />
              }
            />
            <ToggleButton
              size='small'
              icon={
                <Tooltip
                  text='View SQL'
                  placement='top'
                  offset={20}
                  trigger={<Icon kind='Code' size='small' color='navy-900' />}
                />
              }
            />
          </ToggleButtonGroup>
        </span>
      </div>
    </section>
  );
}

export default TableHeader;
